import type { EOpeningAnimation } from "../../../core/EOpeningAnimation";
import { DrawCabinetInsideElement } from "./DrawCabinetInsideElement";

export class DrawInsideTray extends DrawCabinetInsideElement {
    OpeningAnimation!: EOpeningAnimation;
}
